import { render, staticRenderFns } from "./ColumnSettings.vue?vue&type=template&id=b73aabdc&scoped=true&"
import script from "./ColumnSettings.vue?vue&type=script&lang=js&"
export * from "./ColumnSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73aabdc",
  null
  
)

export default component.exports